interface ProgressBarProps {
  currentStep: number;
}

export default function ProgressBar({ currentStep }: ProgressBarProps) {
  const steps = [
    { number: 1, label: 'Sistem' },
    { number: 2, label: 'Video' },
    { number: 3, label: 'Başvuru' },
    { number: 4, label: 'Onay' },
    { number: 5, label: 'Görüşme' }
  ];

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center flex-1">
              <div className="flex flex-col items-center flex-1">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 ${
                  currentStep >= step.number 
                    ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-black shadow-lg shadow-yellow-500/50' 
                    : 'bg-white/10 text-white/50'
                }`}>
                  {step.number}
                </div>
                <span className={`mt-2 text-xs font-medium transition-all duration-300 whitespace-nowrap ${
                  currentStep >= step.number ? 'text-yellow-500' : 'text-white/50'
                }`}>
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className="flex-1 h-0.5 mx-2 relative">
                  <div className="absolute inset-0 bg-white/10"></div>
                  <div 
                    className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-600 transition-all duration-500"
                    style={{ width: currentStep > step.number ? '100%' : '0%' }}
                  ></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}